import React, { useEffect, useState } from "react";
import axios from "axios";
import { API_BASE_URL } from "../config/api";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2"; // SweetAlert2 import kiya gaya hai
import {
  FaSort,
  FaSearch,
  FaCheckCircle,
  FaTimesCircle,
  FaTrashAlt,
  FaArrowLeft
} from "react-icons/fa";

function ParentList() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [activeTab, setActiveTab] = useState("All");
  const [nameSearch, setNameSearch] = useState("");
  const [emailSearch, setEmailSearch] = useState("");
  const [sortConfig, setSortConfig] = useState({
    key: "createdAt",
    direction: "desc",
  });

  const navigate = useNavigate();

  useEffect(() => {
    activeTab === "All" ? fetchParents() : fetchHistory();
  }, [activeTab]);

  const fetchParents = async () => {
    setLoading(true);
    try {
      const res = await axios.get(`${API_BASE_URL}/parent/parents`);
      setData(res.data);
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  const fetchHistory = async () => {
    setLoading(true);
    try {
      const res = await axios.get(`${API_BASE_URL}/parent/history`);
      setData(res.data);
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  const toggleStatus = async (id, currentStatus) => {
    try {
      const newStatus = !currentStatus;
      await axios.put(`${API_BASE_URL}/parent/status/${id}`, { active: newStatus });
      setData(data.map((item) => (item._id === id ? { ...item, active: newStatus } : item)));
    } catch {
      Swal.fire("Error", "Status update nahi ho paya", "error");
    }
  };

  // 🟢 UPDATED DELETE FUNCTION WITH SWEETALERT2
  const deleteParent = async (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#34a87b",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "Cancel"
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          await axios.delete(`${API_BASE_URL}/parent/delete-account/${id}`);
          setData(data.filter((item) => item._id !== id));

          // Success Popup
          Swal.fire({
            title: "Deleted!",
            text: "Parent account has been removed.",
            icon: "success",
            confirmButtonColor: "#34a87b",
          });
        } catch (error) {
          Swal.fire({
            title: "Failed!",
            text: error.response?.data?.message || "Error deleting account",
            icon: "error",
            confirmButtonColor: "#d33",
          });
        }
      }
    });
  };

  const requestSort = (key) => {
    let direction = "asc";
    if (sortConfig.key === key && sortConfig.direction === "asc") direction = "desc";
    setSortConfig({ key, direction });
  };

  const processedData = data
    .filter((item) => {
      const name = activeTab === "All" ? item.name : item.parentId?.name;
      const email = activeTab === "All" ? item.email : item.parentId?.email;
      return (
        name?.toLowerCase().includes(nameSearch.toLowerCase()) &&
        email?.toLowerCase().includes(emailSearch.toLowerCase())
      );
    })
    .sort((a, b) => {
      let aVal = a[sortConfig.key];
      let bVal = b[sortConfig.key];
      if (aVal < bVal) return sortConfig.direction === "asc" ? -1 : 1;
      if (aVal > bVal) return sortConfig.direction === "asc" ? 1 : -1;
      return 0;
    });

  return (
    <div className="p-4" style={{ backgroundColor: "#f8f9fa", minHeight: "100vh" }}>
      <button
        className="btn btn-md d-flex align-items-center gap-2 fw-bold text-muted border-0 bg-transparent mb-3"
        onClick={() => navigate("/dashboard")}
      >
        <FaArrowLeft /> Back
      </button>

      {/* HEADER */}
      <div className="mb-4 p-4 bg-white shadow-sm rounded-4 border-start border-success border-5">
        <h3 className="fw-bold text-dark mb-0">Parents List Management</h3>
      </div>

      {/* TABS */}
      <div className="d-flex align-items-center mb-4 shadow-sm mx-auto bg-white" style={{ borderRadius: "8px", border: "1px solid #d1e7e2", maxWidth: "700px" }}>
        {["All", "History"].map((tab) => (
          <div
            key={tab}
            onClick={() => setActiveTab(tab)}
            className="text-center py-3 fw-semibold"
            style={{
              flex: "1",
              cursor: "pointer",
              backgroundColor: activeTab === tab ? "#34a87b" : "transparent",
              color: activeTab === tab ? "white" : "#555",
              borderRadius: "8px",
              position: "relative",
              transition: "0.3s"
            }}
          >
            {tab === "History" ? "Changed Code" : "Registered"}
            {activeTab === tab && <div className="tab-arrow"></div>}
          </div>
        ))}
      </div>

      {/* SEARCH */}
      <div className="d-flex gap-3 mb-4 flex-wrap justify-content-end">
        <div className="position-relative" style={{ width: "250px" }}>
          <FaSearch className="position-absolute top-50 translate-middle-y ms-3 text-muted" />
          <input
            type="text"
            className="form-control ps-5 border-0 shadow-sm"
            placeholder="Search Name..."
            value={nameSearch}
            onChange={(e) => setNameSearch(e.target.value)}
            style={{ borderRadius: "10px", height: "45px" }}
          />
        </div>
        <div className="position-relative" style={{ width: "250px" }}>
          <FaSearch className="position-absolute top-50 translate-middle-y ms-3 text-muted" />
          <input
            type="text"
            className="form-control ps-5 border-0 shadow-sm"
            placeholder="Search Email..."
            value={emailSearch}
            onChange={(e) => setEmailSearch(e.target.value)}
            style={{ borderRadius: "10px", height: "45px" }}
          />
        </div>
      </div>

      {/* TABLE */}
      {loading ? (
        <div className="text-center mt-5"><div className="spinner-border text-success"></div></div>
      ) : (
        <div className="table-responsive shadow-sm" style={{ borderRadius: "12px", border: "1px solid #e0e0e0", backgroundColor: "white" }}>
          <table className="table table-hover mb-0">
            <thead>
              <tr style={{ fontSize: "15px" }}>
                <th className="py-3 px-4 border-0 pointer" style={{ backgroundColor: "#edf9f5", color: "#333" }} onClick={() => requestSort("name")}>
                  Name <FaSort size={10} className="ms-1 opacity-50" />
                </th>
                <th className="py-3 border-0 text-center pointer" style={{ backgroundColor: "#edf9f5", color: "#333" }} onClick={() => requestSort("email")}>
                  Email <FaSort size={10} className="ms-1 opacity-50" />
                </th>
                {activeTab === "All" ? (
                  <>
                    <th className="py-3 border-0 text-center" style={{ backgroundColor: "#edf9f5" }}>Mobile</th>
                    <th className="py-3 border-0 text-center" style={{ backgroundColor: "#edf9f5" }}>Status</th>
                    <th className="py-3 border-0 text-center" style={{ backgroundColor: "#edf9f5" }}>Action</th>
                  </>
                ) : (
                  <>
                    <th className="py-3 border-0 text-center" style={{ backgroundColor: "#edf9f5" }}>Old School</th>
                    <th className="py-3 border-0 text-center" style={{ backgroundColor: "#edf9f5" }}>Code</th>
                    <th className="py-3 border-0 text-end px-4 pointer" style={{ backgroundColor: "#edf9f5" }} onClick={() => requestSort("createdAt")}>
                      Date <FaSort size={10} className="ms-1 opacity-50" />
                    </th>
                  </>
                )}
              </tr>
            </thead>
            <tbody>
              {processedData.map((item) => (
                <tr key={item._id} className="align-middle">
                  <td className="py-3 px-4 text-dark fw-medium">
                    {activeTab === "All" ? item.name : item.parentId?.name || "N/A"}
                  </td>
                  <td className="py-3 text-center text-secondary">
                    {activeTab === "All" ? item.email : item.parentId?.email || "N/A"}
                  </td>
                  {activeTab === "All" ? (
                    <>
                      <td className="py-3 text-center text-secondary">{item.mobile || "N/A"}</td>
                      <td className="py-3 text-center">
                        <div className="d-flex flex-column align-items-center">
                          <span className="fw-bold mb-1" style={{ fontSize: "10px", color: item.active !== false ? "#34a87b" : "#dc3545" }}>
                            {item.active !== false ? "ACTIVE" : "INACTIVE"}
                          </span>
                          <div className="form-check form-switch">
                            <input
                              className="form-check-input pointer"
                              type="checkbox"
                              checked={item.active !== false}
                              onChange={() => toggleStatus(item._id, item.active !== false)}
                            />
                          </div>
                        </div>
                      </td>
                      <td className="py-3 text-center px-4">
                        <button className="btn btn-sm btn-light border me-2 shadow-sm" onClick={() => navigate(`/dashboard/order/${item._id}`)}>Details</button>
                        <button className="btn btn-sm btn-outline-danger shadow-sm" onClick={() => deleteParent(item._id)}><FaTrashAlt /></button>
                      </td>
                    </>
                  ) : (
                    <>
                      <td className="py-3 text-center text-secondary">{item.oldSchool?.name || "N/A"}</td>
                      <td className="py-3 text-center text-secondary">{item.oldSchool?.schoolCode || "N/A"}</td>
                      <td className="py-3 text-end px-4 text-muted">{new Date(item.createdAt).toLocaleDateString()}</td>
                    </>
                  )}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      <style>{`
        .pointer { cursor: pointer; }
        .tab-arrow {
          position: absolute; bottom: -10px; left: 50%; transform: translateX(-50%);
          width: 0; height: 0; border-left: 8px solid transparent; border-right: 8px solid transparent; border-top: 8px solid #34a87b;
        }
        .form-check-input:checked { background-color: #34a87b; border-color: #34a87b; }
      `}</style>
    </div>
  );
}

export default ParentList;